export enum FunnelName {
  Cicl = "cicl-funnel",
  Cico = "cico-funnel"
}

export enum FunnelCollectionName {
  Checkout = "checkout",
  Offer = "offer",
  Quote = "quote",
  QuoteForm = "quoteForm"
}
